import _ from "lodash";
import { Contact } from "./Contact";
import { DateUtils } from "../utils/DateUtils";
import moment from "moment";

export class Relance {
    id?: number;
    copropriete_id?: number;
    syndic_id?: number;
    copropriete_name: string = "";
    numero_facture: string = "";
    montant: number = 0;
    date_echeance: string = moment().format("YYYY-MM-DD");
    status: Relance.EStatus = Relance.EStatus.Pending;
    created_at?: string;
    updated_at?: string;

    // Relations
    private _copropriete?: Contact;
    private _syndic?: Contact;

    constructor(data: any) {
        let self = this;
        _.assign(self, _.omit(data, ["copropriete", "syndic"]));

        if (data.copropriete) {
            self._copropriete = new Contact(data.copropriete);
        }

        if (data.syndic) {
            self._syndic = new Contact(data.syndic);
        }
    }

    // Getters and setters for relations
    get copropriete(): Contact | undefined {
        return this._copropriete;
    }

    set copropriete(value: Contact | undefined) {
        if (value) {
            this._copropriete = value;
            this.copropriete_id = value.id;
        } else {
            this._copropriete = undefined;
            this.copropriete_id = undefined;
        }
    }

    get syndic(): Contact | undefined {
        return this._syndic;
    }

    set syndic(value: Contact | undefined) {
        if (value) {
            this._syndic = value;
            this.syndic_id = value.id;
        } else {
            this._syndic = undefined;
            this.syndic_id = undefined;
        }
    }

    // Date helpers
    get date_echeance_str(): string {
        return DateUtils.sqlToDateStr(this.date_echeance);
    }

    set date_echeance_str(date: string) {
        var newDate = DateUtils.dateStrToSql(date);
        if (!_.isEmpty(newDate)) {
            this.date_echeance = newDate;
        }
    }

    // Status helpers
    get status_label(): string {
        return Relance.StatusLabels[this.status] || "Inconnu";
    }

    get is_overdue(): boolean {
        return (
            moment().isAfter(moment(this.date_echeance)) &&
            this.status === Relance.EStatus.Pending
        );
    }

    // Utils
    serialize(): Relance.IRelance {
        return {
            id: this.id,
            copropriete_id: this.copropriete_id,
            syndic_id: this.syndic_id,
            copropriete_name: this.copropriete_name,
            numero_facture: this.numero_facture,
            montant: this.montant,
            date_echeance: this.date_echeance,
            status: this.status,
        };
    }
}

export namespace Relance {
    export interface IRelance {
        id?: number;
        copropriete_id?: number;
        syndic_id?: number;
        copropriete_name: string;
        numero_facture: string;
        montant: number;
        date_echeance: string;
        status: EStatus;
    }

    export enum EStatus {
        Pending = 0,
        Paid = 1,
    }

    export const StatusLabels: { [key: number]: string } = {
        [EStatus.Pending]: "En attente",
        [EStatus.Paid]: "Payée",
    };
}
